const TriangleToolIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  const size = "24px";

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.3335 14.6654L14.6668 1.33203V14.6654H1.3335ZM4.55016 13.332H13.3335V4.56536L4.55016 13.332Z"
        fill={finalColor}
      />
    </svg>
  );
};

export default TriangleToolIcon;
